import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser((prev) => (prev ? prev : r.data)))
      .catch(() => setUser((prev) => (prev ? prev : false)));
  }, []);

  const persist = (data) => {
    if (data.token) setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return persist(data);
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return persist(data);
  };

  const refresh = async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch (e) { return null; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed", e); }
    clearToken();
    setUser(false);
  };

  const hasRole = (...roles) => {
    if (!user || !user.roles) return false;
    if (user.roles.includes("admin")) return true;
    return roles.some((r) => user.roles.includes(r));
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, hasRole, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
